import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { NotificationComponent } from '../shared/notification/notification.component';
import { NOTIFICATION_MESSAGES } from '../utility/notification-messages';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private readonly snackBar: MatSnackBar) {}

  success(message: string, duration = 4000): void {
    const config: MatSnackBarConfig =  {
      data: {message, type: 'success', duration},
      duration,
      politeness: 'polite',
      horizontalPosition: 'right',
      verticalPosition: 'bottom'
    } 
    this.snackBar.openFromComponent(NotificationComponent, config);
  }

  error(message: string, duration = 8000): void {
    const config: MatSnackBarConfig = {
      data: {message, type: 'error', duration},
      duration,
      politeness: 'assertive',
      horizontalPosition: 'right',
      verticalPosition: 'bottom'
    }
    this.snackBar.openFromComponent(NotificationComponent, config);
  }

  entitySuccess(action: 'add' | 'update' | 'delete', entity: string): void {
    const msg = NOTIFICATION_MESSAGES.success[action](entity);
    this.success(msg);
  }

  entityError(action: 'add' | 'update' | 'delete', entity: string): void {
    const msg = NOTIFICATION_MESSAGES.error[action](entity);
    this.error(msg);
  }

  genericError(): void {
    const msg = NOTIFICATION_MESSAGES.error.generic();
    this.error(msg);
  }

  associatedEntityError(msg: string){ 
    this.error(msg);
  }

  successOnSave(): void {
    const msg = NOTIFICATION_MESSAGES.success.generic();
    this.success(msg);
  }

  successOnUpload(entity: string): void {
    const msg = NOTIFICATION_MESSAGES.success.upload(entity);
    this.success(msg);
  }

  errorOnUpload(entity: string): void {
    const msg = NOTIFICATION_MESSAGES.error.upload(entity);
    this.error(msg);
  }

  successOnDownload(entity: string): void {
    const msg = NOTIFICATION_MESSAGES.success.download(entity);
    this.success(msg);
  }

  errorOnDownload(entity: string): void {
    const msg = NOTIFICATION_MESSAGES.error.download(entity);
    this.error(msg);
  }

  restrictedSection(): void {
    const msg = NOTIFICATION_MESSAGES.error.restricted();
    this.error(msg);
  }

  getAutolearningInfoError(): void {
    const msg = NOTIFICATION_MESSAGES.error.autolearning();
    this.error(msg);
  }

  importError(): void {
    const msg = NOTIFICATION_MESSAGES.error.import();
    this.error(msg);
  }

  
  exportError(): void {
    const msg = NOTIFICATION_MESSAGES.error.export();
    this.error(msg);
  }

  importSuccess(): void {
    const msg = NOTIFICATION_MESSAGES.success.import();
    this.success(msg);  
  }

  
  exportSuccess(): void {
    const msg = NOTIFICATION_MESSAGES.success.export();
    this.success(msg);
  }

  stateSuccess(entity: string){
    const msg = NOTIFICATION_MESSAGES.success.state(entity);
    this.success(msg);
  }

  stateError(entity: string){
    const msg = NOTIFICATION_MESSAGES.error.state(entity);
    this.error(msg);
  }

  indexingSuccess(){
    const msg = NOTIFICATION_MESSAGES.success.indexing();
    this.success(msg);
  }

  indexingError(){
    const msg = NOTIFICATION_MESSAGES.error.indexing();
    this.error(msg);
  }

}
